export const noten = {
  "": "",
  "00": "6",
  "01": "5-",
  "02": "5",
  "03": "5+",
  "04": "4-",
  "05": "4",
  "06": "4+",
  "07": "3-",
  "08": "3",
  "09": "3+",
  10: "2-",
  11: "2",
  12: "2+",
  13: "1-",
  14: "1",
  15: "1+",
};
export const notenOptions = Object.keys(noten)
  .sort()
  .reverse()
  .map((i) => {
    return { key: i, value: `${i}${i ? ` (Note: ${noten[i]})` : ""}` };
  });
// console.log({ notenOptions });
